// extracted by mini-css-extract-plugin
export default {"button-wrapper":"button-wrapper---Xgc5T","button-container":"button-container---UJzNJ","prev-next-page-info":"prev-next-page-info---qrcQz"};